export default (size) => 
  `<svg class="Spinner" width="${size}" height="${size}" viewBox="0 0 100 100" xmlns="http://www.w3.org/2000/svg">
  <circle class="Spinner-inner" cx="50" cy="50" r="35" fill="none" stroke-width="${100 / size * 4}px" stroke="#ccc" />
  </svg>`


// WEBPACK FOOTER //
// ./scripts/templates/spinner.js